import React, { Fragment, useContext, useState, useEffect } from "react";
/// React router dom
import { Link, useLocation } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import jharkhandlogo1 from "../../../images/jharkhandlogo1.png";
import jharkhandlogo2 from "../../../images/jharkhandlogo2.png";
import jharkhandlogo3 from "../../../images/jharkhand logo3.png";
import { useSelector } from "react-redux";
import "./style.css";

export function NavMenuToggle() {
  setTimeout(() => {
    let mainwrapper = document.querySelector("#main-wrapper");
    if (mainwrapper.classList.contains("menu-toggle")) {
      mainwrapper.classList.remove("menu-toggle");
    } else {
      mainwrapper.classList.add("menu-toggle");
    }
  }, 200);
}

const NavHader = () => {
  const loginDetails = localStorage.getItem("login_Details");
  const isSidebarOpen = useSelector((state) => state.ui.isSidebarOpen);
  const [redirectTo, setRedirectTo] = useState("/");
  const loginFullDetails = JSON.parse(loginDetails);
  const [toggle, setToggle] = useState(false);
  const { navigationHader, background } = useContext(ThemeContext);
  const userType = localStorage.getItem("user_type");





  useEffect(() => {
    const userType = localStorage.getItem("user_type");
    const loginDetails = JSON.parse(localStorage.getItem("login_Details"));

    if (loginDetails?.user?.user_level == process.env.REACT_APP_VENUE_MANAGER_USER_LEVEL) {
      setRedirectTo("/venue-manager");
    } else if (userType === "user") {
      setRedirectTo(process.env.REACT_APP_WEBSITE_URL || "/Organization");
    } else {
      setRedirectTo("/");
    }
  }, []);


  const location = useLocation();
  const rawSegments = location.pathname.split("/").filter(Boolean);
  const pageLabel = rawSegments.length > 0
    ? rawSegments[rawSegments.length - 1]
        .split("-")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
    : "Home";

  return (
    <div className="nav-header border-bottom  navbar-height border-bottom-left-round white ">
      {/* Mobile: hamburger left + logo right */}
      <div className="d-flex d-md-none align-items-center justify-content-between w-100 px-2 mobile-nav-row">
        <button
          className="btn btn-sm mobile-hamburger"
          aria-label="Toggle sidebar"
          onClick={NavMenuToggle}
        >
          <i className="fa fa-bars" />
        </button>
        <Link to={redirectTo}>
          <img src={jharkhandlogo1} alt="logo" style={{height:"36px"}} />
        </Link>
      </div>
      {/* Desktop: existing brand-logo */}
      <Link to={redirectTo} className={`brand-logo d-none d-md-flex ${isSidebarOpen ? ("ml-negative") : "ml-negative-center"}`}>
        {background.value === "dark" || navigationHader !== "color_1" ? (
          <Fragment>
            <div className="d-flex ">
              <div>
                <img src={jharkhandlogo1} alt="logo" />
              </div>
              {/* <div>
                <img src={jharkhandlogo2} alt="logo" />
              </div>
              <div>
                <img src={jharkhandlogo3} alt="logo" />
              </div> */}
            </div>

            <div className="brand-title">
              <span className="brand-sub-title">
                {loginFullDetails?.user?.name}
              </span>
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div className="d-flex align-items-center justify-content-between gap-2">
              {userType === "user" ?
                <div>
                  <img
                    src={jharkhandlogo1}
                    alt="logo"
                    className={`${!isSidebarOpen ? "large_Width_logo_fixed" : "logo_img large_Width_logo_user"}`}
                  />
                </div> :
                <div>
                  <img
                    src={jharkhandlogo1}
                    alt="logo"
                    className={`${!isSidebarOpen ? "large_Width_logo_fixed" : "logo_img large_Width_logo"}`}
                  />
                </div>
              }

              {/* <div>
                <img
                  src={jharkhandlogo2}
                  alt="logo"
                  className={`${toggle ? "logo_img_small" : "logo_img"}`}
                />
              </div>
              <div>
                <img
                  src={jharkhandlogo3}
                  alt="logo"
                  className={`${toggle ? "logo_img_small" : "logo_img"}`}
                />
              </div> */}
              {isSidebarOpen && (
                <div className="brand-title">
                  <div className="brand-sub-title pt-2">
                    {loginFullDetails?.user?.name}
                  </div>
                </div>
              )}
            </div>

          </Fragment>
        )}
      </Link>

      {/* <div
        className="nav-control"
        onClick={() => {
          setToggle(!toggle);
          NavMenuToggle();
        }}
      >
        <div className={`hamburger ${toggle ? "is-active" : ""}`}>
          <span className="line"></span>
          <span className="line"></span>
          <span className="line"></span>
        </div>
      </div> */}
    </div>
  );
};

export default NavHader;
